// extracted by mini-css-extract-plugin
export default {"hiddenInput":"WithdrawReportUploader_hiddenInput__4f9-g","parsedDetails":"WithdrawReportUploader_parsedDetails__6WC8Q"};